import React from 'react';
import classnames from 'classnames';
import Icons from 'components/icons';
import styles from './button-add.module.scss';

const ButtonAdd = ({ children, className, ...rest }) => (
  <div className={classnames(styles.add, className)} {...rest}>
    <Icons name="add" />
    <span>{children}</span>
  </div>
);

export default ButtonAdd;
